import numeral from 'numeral';
import _ from 'lodash';

import { useEffect, useRef, useState } from 'react';
import ScaleLoader from 'react-spinners/ScaleLoader';
import { APP_IMG } from 'src/constants';

const WidgetBitkub = () => {
  const ws = useRef(null);
  const [dataTicker, setDataTicker] = useState([
    {
      id: 1,
      title: 'BTC',
      icon: `${APP_IMG}/images/bitkub/BTC.png`,
      link: 'https://onelink.bitkub.com/aHvr/bbnbtc',
      data: null
    },
    {
      id: 2,
      title: 'ETH',
      icon: `${APP_IMG}/images/bitkub/ETH.png`,
      link: 'https://onelink.bitkub.com/aHvr/bbneth',
      data: null
    },
    {
      id: 35,
      title: 'DOGE',
      icon: `${APP_IMG}/images/bitkub/DOGE.png`,
      link: 'https://onelink.bitkub.com/aHvr/bbndoge',
      data: null
    },
    {
      id: 4,
      title: 'ADA',
      icon: `${APP_IMG}/images/bitkub/ADA.png`,
      link: 'https://onelink.bitkub.com/aHvr/bbnada',
      data: null
    },
    {
      id: 33,
      title: 'BNB',
      icon: `${APP_IMG}/images/bitkub/BNB.png`,
      link: 'https://onelink.bitkub.com/aHvr/bbnbnb',
      data: null
    },
    {
      id: 92,
      title: 'KUB',
      icon: `${APP_IMG}/images/bitkub/KUB.png`,
      link: 'https://onelink.bitkub.com/aHvr/bbnkub',
      data: null
    }
  ]);

  useEffect(() => {
    ws.current = new WebSocket(
      'wss://api.bitkub.com/websocket-api/market.ticker.thb_btc,market.ticker.thb_eth,market.ticker.thb_doge,market.ticker.thb_ada,market.ticker.thb_bnb,market.ticker.thb_kub'
    );
    // ws.current = new WebSocket('wss://api.bitkub.com/websocket-api/market.trade.thb_btc');
    // ws.current.onopen = () => console.log('ws opened');
    // ws.current.onclose = () => console.log('ws closed');

    ws.current.onmessage = async e => {
      try {
        const ticker = JSON.parse(e?.data);
        // console.log(ticker);
        const updateTicker = dataTicker.findIndex(item => item.id === ticker.id);
        const newArray = [...dataTicker];
        newArray[updateTicker] = { ...newArray[updateTicker], data: ticker };
        await setDataTicker(newArray);
      } catch (error) {
        console.error('WebSocket Error');
      }
    };

    return () => {
      ws.current.close();
    };
  }, [dataTicker]);

  const checkNumSign = data => {
    if (Math.sign(data) === -1) {
      return true;
    }
    return false;
  };

  // console.log(dataTicker);
  return (
    <div className='widget-bitkub'>
      <div className='widget-bitkub-heading'>
        <a href='https://www.bitkub.com/signup?ref=2486094' target='_blank' rel='noreferrer noopener'>
          <img src={`${APP_IMG}/images/bitkub/logo.png`} alt='bitkub' width='100%' height='100%' />
        </a>
      </div>
      <div className='widget-bitkub-table'>
        <ul className='table-heading'>
          <li>สกุลเงิน</li>
          <li>ราคาล่าสุด (THB)</li>
          <li>ซื้อขาย/วัน</li>
        </ul>
        {dataTicker.map((item, index) => (
          <ul key={index} className='table-list'>
            <li>
              <a href={item.link} target='_blank' rel='noreferrer noopener'>
                <img src={item.icon} alt={item.title} width='100%' />
                <span>{item.title}</span>
              </a>
            </li>
            <li>
              {item.data === null ? (
                <ScaleLoader height={8} width={2} radius={2} margin={2} color={'#02d667'} />
              ) : (
                <span className={`${checkNumSign(item.data?.percentChange) ? 'negative' : 'positive'}`}>
                  {numeral(item.data.last).format('0,0')} ({item.data?.percentChange}%)
                </span>
              )}
            </li>
            <li>
              {item.data === null ? <ScaleLoader height={8} width={2} radius={2} margin={2} color={'#02d667'} /> : numeral(item.data.baseVolume).format('0,0')} {item.title}
            </li>
          </ul>
        ))}
      </div>
    </div>
  );
};

export default WidgetBitkub;
